module.exports = {
  videoData: () => {
    return{
      "IONIQ 5 EV-POWER": "https://www.youtube.com/embed/1P_bUccK2yk",
      "TUCSON HEV LIMITED": "https://www.youtube.com/embed/SZ9EKPu4Se8",
      "PALISADE SPORT": "https://www.youtube.com/embed/6mecS35YDpg",
      "STARIA LUJO": "https://www.youtube.com/embed/jeTvEPudqxQ",
      "VENUE LIMITED AT": "https://www.youtube.com/embed/pTOu8JHS05Q",
      "HB20 ADVANCE": "https://www.youtube.com/embed/z78NtvCtXkM",
      "HB20S ADVANCE": "https://www.youtube.com/embed/prJ1mJKbKwU",
      //"CRETA PREMIUM": "https://www.youtube.com/embed/VRWk0SixWvo",
      "CRETA PREMIUM": "https://www.youtube.com/embed/Zj8XobPZXG0",
      "KONA HEV LIMITED": "https://www.youtube.com/embed/CYU1h-wZgAo",
      "SANTA FE HEV LIMITED 4x4": "https://www.youtube.com/embed/l6FXuAUCYt0",

      "GRAND i10 AT PREMIUM": "https://www.youtube.com/embed/2mnt4T_MRU0",
      "PALISADE HEV 4x4": "https://www.youtube.com/embed/2mnt4T_MRU0",
    }
  }
}